import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";
import reqVendaItem from "../../../../services/reqMultiTenant/reqVendaItem";
import MainReportMatrix from "../../matrix";
const ReportsWhatsAppLeads = (props) => {
	const options = {
		title: "Leads WhatsApp",
		subTitle: "Relatório de Leads WhatsApp",
		ident: "leadsWhatsapp", //usado para definir os event listners
		identFilter: "filterLeadsWhatsapp", //usado para definir os event listners
		identReport: "reportLeadsWhatsapp", //usado para definir os event listners
		tableColumns: [
			{ key: "nome", label: "Nome", align: "left" },
			{ key: "qt", label: "Vendidos", align: "center" },
			{ key: "perc", label: "Percentual", align: "left" },
			{ key: "status", label: "Status", align: "center" },
			{ key: "qtatual", label: "Estoque", align: "center" },
			{ key: "qtcritica", label: "Qt. Crítica", align: "center" },
		],
		reportColumns: [
			{ key: "nome", label: "Nome", align: "left" },
			{ key: "qt", label: "Vendidos", align: "center" },
			{ key: "perc", label: "Percentual", align: "left" },
			{ key: "status", label: "Status", align: "center" },
			{ key: "qtatual", label: "Estoque", align: "center" },
			{ key: "qtcritica", label: "Qt. Crítica", align: "center" },
		],

		showTime: true, //mostra a hora no filtro de data
		hasActive: false, //ativa o filtro de ativo
		hasSaleType: false,
		parametersDate: [{ id: 1, label: "Data contato do lead", value: "dtVenda" }],
		parametersFilter: [
			// { id: 1, label: "Grupo", value: "grupo" },
			// { id: 2, label: "SubGrupo", value: "subgrupo" },
			// { id: 3, label: "Fornecedor", value: "fornecedor" },
			{ id: 1, label: "Referência", value: "referencia" },
		],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };

		const response = await reqVendaItem.listSoldProducts(newFilterData);

		return response;
	};

	//chama o relatório passando os options e a função fetch e o filtro de pesquisa
	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} FormFilter={FilterReportDateItens}></MainReportMatrix>
		</div>
	);
};

export default ReportsWhatsAppLeads;
